module.exports = __webpack_public_path__ + "static/media/trending-up.7f151ade.svg";